/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

/*import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ExaminationApi } from '../api/examination.api';
import { switchMap, map } from 'rxjs/operators';
import { ExaminationData, Examination } from '../../../interfaces/masters/examination';

@Injectable()
export class ExaminationService extends ExaminationData {

  constructor(private api: ExaminationApi) {
    super();
  }


  list(): Observable<Examination[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Examination>{
      return this.api.getById(url);
  }

  create(url: string, data:Examination): Observable<Examination> {
    return this.api.add(url,data);
  }

  update(url: string, data:Examination): Observable<Examination> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}*/
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ExaminationApi } from '../api/examination.api';
import { switchMap, map } from 'rxjs/operators';
import { ExaminationData, Examination } from '../../../interfaces/masters/examination';

@Injectable()
export class ExaminationService extends ExaminationData {

  constructor(private api: ExaminationApi) {
    super();
  }

  list(url: string): Observable<Examination[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Examination>{
      return this.api.getById(url);
  }

  create(url: string, data:Examination): Observable<Examination> {
    return this.api.add(url,data);
  }

  update(url: string, data:Examination): Observable<Examination> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}

